<template>
    <v-avatar size="36" class="align-self-center ml-2">
        <v-tooltip top color="primary" v-if="locale">
            <template v-slot:activator="{ on }">
                <v-img v-on="on" :src="locale.image" class="mt-1 mr-1"/>
            </template>
            {{ locale.country }} - {{ locale.language }}
        </v-tooltip>

        <v-tooltip v-else top color="primary" >
            <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="36" color="grey lighten-2">mdi-earth</v-icon>
            </template>
            Auto detect country and language
        </v-tooltip>
    </v-avatar>
</template>

<script>

import Json from 'vue-json-pretty';

export default {

    components: {
        Json
    },

    props: {
        locale: {
            type: Object,
            required: false,
            default: null,
        }
    },
}
</script>
